import { Tool } from '~/packages/tools/tools.typing'
import fetchLegalEntityAttendanceSizeAction from './queries/fetchLegalEntityAttendanceSize/fetchLegalEntityAttendanceSize.action.json'
import expression from '~/prix/types/expression'
import { legalEntityExpression } from '../legalEntity/stats/legalEntityStats.definition'
import { pick } from '~/prix/utils/types/object'

export const legalEntitySizeMapTool = {
  key: 'legalEntitySizeMap',
  title: 'Distribuição territorial por porte',
  label: 'Estabelecimentos atendidos por porte',
  description:
    'Mostra estabelecimentos atendidos por Agentes SEBRAE Na Sua Empresa agrupados por porte, usando o endereço cadastral da Receita Federal do Brasil para localização.',
  categoryKey: 'appSebraeAttendance',
  categoryKeys: ['appSebraeAttendance'],
  unitSingular: 'estabelecimento atendido',
  unitPlural: 'estabelecimentos atendidos',
  grammaticalGender: 'male',
  path: '/app/map/legal-entity-size',
  timeType: 'incidence',
  restrictView: ['space'],
  actionDefinitionKey: fetchLegalEntityAttendanceSizeAction.key,
  isListed: true,
  filterableBy: expression(pick(legalEntityExpression.shape, ['agentCpf'])),
} satisfies Tool & { actionDefinitionKey: string }

export default async function getLegalEntitySizeTools() {
  return [legalEntitySizeMapTool]
}
